import { TimelineContent, TimelineItem, TimelineSeparator } from "@mui/lab";
import { Box, ListItemText, styled, Typography } from "@mui/material";

export const StyledTimelineSeparator = styled(TimelineSeparator)(() => ({
  marginRight: "8px",
  "& .MuiTimelineConnector-root": {
    backgroundColor: "#E6E6E6",
  },
  "& .MuiTimelineDot-root.MuiTimelineDot-filled": {
    margin: "4px 0",
    backgroundColor: "#E6E6E6",
    height: "30px",
    width: "30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

export const StyledHeader = styled(Box)(() => ({
  borderBottom: "1px solid #E6E7E7",
  padding: "26px",
  color: "#052223",
}));

export const StyledSkeletonBox = styled(Box)(() => ({
  padding: "0 17px 0px 17px",
}));

export const StyledTimelineContent = styled(TimelineContent)(() => ({
  padding: "12px 16px",
  paddingTop: 0,
}));

export const StyledTimelineItem = styled(TimelineItem)(() => ({
  minHeight: "55px",
}));

export const StyledListItemText = styled(ListItemText)(() => ({
  display: "flex",
  alignItems: "center",
}));

export const StyledCaption = styled(Typography)(() => ({
  color: "#A9A9A9",
  fontSize: "0.625rem",
}));

export const StyledBody2 = styled(Typography)(() => ({
  fontWeight: 400,
  color: "#7F7D83",
}));

export const HighlightedText = styled("span")(() => ({
  color: "#030712",
  fontWeight: 500,
}));
